// O painel de categorias que abre a partir do «Loja».
//
// Abre por clique, não por passagem do rato: no telemóvel não há rato, e num
// portátil um painel que salta ao passar por cima é o que faz as pessoas
// fecharem menus sem querer. Um clique abre, outro fecha.
//
// A seta só aparece quando este script corre. Sem JavaScript o «Loja»
// continua a ser uma ligação normal para o catálogo — não fica um botão morto
// na barra.

(function () {
	function iniciar() {
		var botao = document.querySelector(".ct-mega-botao");
		var painel = document.getElementById("ct-mega-painel");
		if (!botao || !painel) return;

		var item = botao.closest(".ct-mega-item");
		var menuColapsado = document.getElementById("navbarSupportedContent");

		function fechar(devolverFoco) {
			painel.hidden = true;
			botao.setAttribute("aria-expanded", "false");
			if (devolverFoco) botao.focus();
		}

		function alternar() {
			var estavaFechado = painel.hidden;
			painel.hidden = !estavaFechado;
			botao.setAttribute("aria-expanded", String(estavaFechado));
		}

		botao.hidden = false;
		botao.addEventListener("click", alternar);

		// Clicar fora fecha. A verificação é pelo `.ct-mega-item` inteiro e não
		// só pelo painel: o clique no próprio botão também cai aqui, e sem isto
		// fechava e reabria no mesmo gesto.
		document.addEventListener("click", function (evento) {
			if (!item.contains(evento.target)) fechar();
		});

		// Escape fecha e devolve o foco ao botão — quem navega por teclado tem
		// de saber onde ficou.
		document.addEventListener("keydown", function (evento) {
			if (evento.key === "Escape" && !painel.hidden) {
				evento.preventDefault();
				fechar(true);
			}
		});

		// Sair do painel com Tab fecha-o. Sem isto, quem continua a tabular
		// deixa um painel aberto atrás de si, por cima da página.
		item.addEventListener("focusout", function (evento) {
			if (!item.contains(evento.relatedTarget)) fechar();
		});

		// No telemóvel o painel vive dentro do menu que colapsa: se o menu
		// fecha, o painel tem de fechar com ele.
		if (window.jQuery && menuColapsado) {
			window.jQuery(menuColapsado).on("hide.bs.collapse", function () { fechar(); });
		}

		// Mudar de telemóvel para computador (rodar o ecrã, redimensionar a
		// janela) troca o desenho do painel; fechá-lo evita que fique aberto
		// com o desenho errado.
		var largura = window.matchMedia("(min-width: 992px)");
		if (largura.addEventListener) {
			largura.addEventListener("change", function () { fechar(); });
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", iniciar);
	} else {
		iniciar();
	}
})();
